module.exports = __webpack_public_path__ + "static/media/bg.21030236.jpg";